import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';
import { ResourcefulIndexModule } from 'src/app/shared/resourceful-index/resourceful-index.module';
import { RicercaGenericaAnagraficheModule } from '../ricerca-generica-anagrafiche/ricerca-generica-anagrafiche.module';
import { CompagnieRoutingModule } from './compagnie-routing.module';
import { CompagnieComponent } from './compagnie.component';
import { CompagnieFormComponent } from './dialogs/form/form.component';



@NgModule({
  declarations: [CompagnieComponent, CompagnieFormComponent],
  imports: [
    CommonModule,
    CompagnieRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CustomMaterialModule,
    ResourcefulIndexModule,
    CustomFormControlsModule,
    RicercaGenericaAnagraficheModule,

  ]
})
export class CompagnieModule { }
